
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/cookie-policy",
      function () {
        return require("private-next-pages/docs/cookie-policy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/cookie-policy"])
      });
    }
  